export const UPLOAD_DIALOG_ID = 'upload-dlg';
